const serializeDataToSessionStorage = (id, data) => sessionStorage
    .setItem(id, JSON.stringify(data));

export default serializeDataToSessionStorage;
